// src/auth/Signup.js
// 13.06.25 03:15 - Added PDF test function for NDIS agreement generation testing
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { httpsCallable } from "firebase/functions";
import { functions } from '../../firebase'; // 13.06.25 03:15 - Added for PDF testing
import './Auth.css';

export default function Signup() {
  const navigate = useNavigate();
  const { signup } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  // Form state
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [personalEmail, setPersonalEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  // 13.06.25 03:16 - PDF test function for NDIS agreement generation
  const testPDFGeneration = async () => {
    try {
      console.log('🧪 Starting NDIS PDF generation test...');
      
      const generatePDF = httpsCallable(functions, 'generateNDISAgreementLight');
      
      const testData = {
        participantName: "John Smith Test",
        ndisNumber: "1234567890",
        dateOfBirth: "01/01/1990",
        userEmail: "test@cooc.com.au",
        planManagerName: "Test Manager",
        planManagerEmail: "manager@test.com",
        digitalSignature: "John Smith Test"
      };
      
      console.log('📋 Test data:', testData);
      
      const result = await generatePDF(testData);
      console.log('✅ PDF Generation Result:', result.data);
      
      if (result.data.success) {
        alert(`✅ PDF Generated Successfully!\n\nFile: ${result.data.fileName}\nDownload URL available in console\n\nCheck Firebase Storage for the generated PDF.`);
      } else {
        alert('❌ PDF generation failed - check console for details');
      }
      
    } catch (error) {
      console.error('❌ PDF Generation Error:', error);
      alert('Error generating PDF: ' + error.message);
    }
  };
  
  // Form submission
  async function handleSubmit(e) {
    e.preventDefault();
    
    // Form validation
    if (password !== confirmPassword) {
      return setError('Passwords do not match');
    }
    
    try {
      setError('');
      setLoading(true);
      
      // Prepare basic user data
      const userData = {
        firstName: firstName,
        lastName: lastName,
        displayName: `${firstName} ${lastName}`,
        accountStatus: 'verification_pending',
        setupComplete: false
      };
      
      // Create user in Firebase Authentication
      await signup(personalEmail, password, userData);
      
      // Redirect to NDIS verification with user details
      navigate('/ndis-verification', { 
        state: { 
          userDetails: {
            firstName,
            lastName
          }
        }
      });
    } catch (error) {
      setError('Failed to create an account: ' + error.message);
      setLoading(false);
    }
  }

  return (
    <div className="auth-container">
      <div className="auth-form-container">
        <h2>Sign Up for COOC</h2>
        
        {/* 13.06.25 03:17 - PDF Test Button */}
        <button 
          onClick={testPDFGeneration}
          style={{
            background: '#FF0000', 
            color: 'white', 
            padding: '15px 20px',
            border: 'none',
            borderRadius: '5px',
            fontSize: '14px',
            cursor: 'pointer',
            margin: '20px 0',
            width: '100%',
            fontWeight: 'bold'
          }}
        >
          🧪 Test NDIS PDF Generation
        </button>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>First Name</label>
            <input 
              type="text" 
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required 
            />
          </div>
          
          <div className="form-group">
            <label>Last Name</label>
            <input 
              type="text" 
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required 
            />
          </div>
          
          <div className="form-group">
            <label>Personal Email</label>
            <input 
              type="email" 
              value={personalEmail}
              onChange={(e) => setPersonalEmail(e.target.value)}
              required 
            />
            <small>This will be used for login and authentication</small>
          </div>
          
          <div className="form-group">
            <label>Password</label>
            <input 
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required 
            />
          </div>
          
          <div className="form-group">
            <label>Confirm Password</label>
            <input 
              type="password" 
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required 
            />
          </div>
          
          <button type="submit" className="auth-button" disabled={loading}>
            Continue to NDIS Verification
          </button>
        </form>
        
        <div className="auth-footer">
          Already have an account? <Link to="/login">Log In</Link>
        </div>
      </div>
    </div>
  );
}